import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';
import { Comment, FirestoreComment } from '@jessie/commons';
import { FirestoreOrgaUser } from '@jessie/commons';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { CommentComponent } from '../comment/comment.component';

import { NewCommentComponent } from '../new-comment/new-comment.component';

@Component({
  selector: 'app-comment-list',
  templateUrl: './comment-list.component.html',
  styles: [
    `
      @reference "tailwindcss";
      :host {
        @apply flex flex-col h-full;
      }
    `,
  ],
  imports: [NewCommentComponent, CommentComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommentListComponent {
  @Input() comments!: FirestoreComment[];
  @Input() orgaUsers!: FirestoreOrgaUser[];
  @Input() loggedInUserId!: string;
  @Input() set padded(value: any) {
    this._padded = coerceBooleanProperty(value);
  }

  @Output() createNewComment = new EventEmitter<Partial<Comment>>();
  @Output() deleteComment = new EventEmitter<FirestoreComment>();
  @Output() markAsReacted = new EventEmitter<{ comment: FirestoreComment; userId: string }>();

  @HostBinding('class.padded') _padded = false;

  trackById(index: number, item: any): any {
    return item.id;
  }
}
